import { cn } from "@/lib/utils";
import React, { useEffect, useRef, useState } from "react";

interface SidebarProps {
  data: {
    label: string;
  }[];
  onClick?: (label: string) => void;
  active: string | undefined;
}

export const MobileHeader = ({ data, onClick, active }: SidebarProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const [disableAutoScroll, setDisableAutoScroll] = useState<boolean>(false);
  const handleArrowClick = (direction: "left" | "right") => {
    if (containerRef.current) {
      const scrollAmount = direction === "left" ? -100 : 100; // Adjust this value to scroll more or less

      containerRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };
  const checkScrollPosition = () => {
    const container = containerRef.current;
    if (container) {
      const scrollLeft = container.scrollLeft; // Current scroll position
      const scrollWidth = container.scrollWidth; // Total width of the scrollable area
      const clientWidth = container.clientWidth; // Width of the visible area

      setAtStart(scrollLeft === 0); // Check if at the start
      setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1); // Check if at the end
    }
  };

  useEffect(() => {
    checkScrollPosition();
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", checkScrollPosition);
      if (container && active) {
        if (disableAutoScroll) return;
        const activeElements = containerRef.current?.querySelectorAll("p");
        activeElements.forEach((element) => {
          setTimeout(() => {
            if (element.classList.contains("border-[#303030]")) {
              element.scrollIntoView({ behavior: "instant", inline: "center" });
            }
          }, 200);
        });
      }
      return () => container.removeEventListener("scroll", checkScrollPosition);
    }
  }, [active]);

  return (
    <div className="hidden bg-[#F2F2F2] border-[#E5E5E5] border-solid border-[1px] max-md:block w-full sticky max-sm:fixed top-[55px] z-[50]">
      {!atStart && (
        <div className="  left-0 grid h-full bg-gradient-to-r from-[#F6F6F5] items-center min-w-[80px] z-10 top-0 absolute">
          <img
            src="/arrow-right.svg"
            alt="Scroll Left"
            className="rotate-180 cursor-pointer"
            onClick={() => handleArrowClick("left")}
          />
        </div>
      )}
      <div
        ref={containerRef}
        className="flex flex-row items-center gap-6 mq450:px-5 px-12 overflow-x-auto whitespace-nowrap scroll-smooth font-sh5 text-other-cta"
      >
        {data.map((item, index) => (
          <p
            key={item.label}
            onClick={() => {
              setDisableAutoScroll(true);
              if (typeof onClick == "function") onClick(item.label as string);
              setTimeout(() => {
                setDisableAutoScroll(false);
              }, 1000);
            }}
            className={cn(
              "py-4 border-b-[1.5px] border-solid cursor-pointer border-transparent text-gray-60 whitespace-nowrap text-sm",
              active === item.label && "border-[#303030] text-gray-100",
            )}
          >
            {item.label}
          </p>
        ))}
        {!atEnd && (
          <div className="absolute right-0 grid h-full bg-gradient-to-l from-[#F6F6F5]  min-w-[80px] z-10 items-center justify-end">
            <img
              src="/arrow-right.svg"
              alt="Scroll Right"
              className="mb-1 cursor-pointe"
              onClick={() => handleArrowClick("right")}
            />
          </div>
        )}
      </div>
    </div>
  );
};
